export interface VehicleDropdownActionType {
  type: VehicleDropdown;
  payload?: any;
}

export enum VehicleDropdown {
  GET_VEHICLE_DROPDOWN_LIST = "GET_VEHICLE_DROPDOWN_LIST",
  SET_VEHICLE_DROPDOWN_LIST = "SET_VEHICLE_DROPDOWN_LIST",
  SET_VEHICLE_DROPDOWN_LOADING = "SET_VEHICLE_DROPDOWN_LOADING",
}
